export default function iconButton({ variables, }) {
    return {
        MuiIconButton: {
            styleOverrides: {
                root: {
                    borderRadius: variables.border_radius_small,
                    color: variables.text_medium,
                    "&:hover": {
                        backgroundColor: variables.surface_hover,
                        color: variables.text_primary,
                    },
                },
                sizeSmall: {
                    height: variables.component_height_small,
                    width: variables.component_height_small,
                    padding: variables.spacing_02,
                },
                sizeMedium: {
                    height: variables.component_height_medium,
                    width: variables.component_height_medium,
                    padding: variables.spacing_02,
                },
                sizeLarge: {
                    height: variables.component_height_large,
                    width: variables.component_height_large,
                    padding: variables.spacing_02,
                },
            },
        },
    };
}
//# sourceMappingURL=iconButton.js.map